import React from "react";

interface MessageTextareaProps {
  value: string;
  onChange: (value: string) => void;
  onFocus: () => void;
  onBlur: () => void;
  fieldTextStyle: React.CSSProperties;
  maxLength: number;
  focused: string | null;
  setFocused: (field: string | null) => void;
}

const MessageTextarea: React.FC<MessageTextareaProps> = ({
  value,
  onChange,
  onFocus,
  onBlur,
  fieldTextStyle,
  maxLength,
  focused,
  setFocused,
}) => {
  const neutralBorder = "#818181";

  return (
    <div className="mt-5 md:mt-6">
      <div className="relative">
        <label htmlFor="message" className="sr-only">Message (optional)</label>
        <textarea
          id="message"
          value={value}
          onChange={(e) => onChange(e.target.value.slice(0, maxLength))}
          maxLength={maxLength}
          onFocus={() => { setFocused("message"); onFocus(); }}
          onBlur={() => { if (focused === "message") setFocused(null); onBlur(); }}
          rows={4}
          placeholder="(Optional) ¿Podrías decirnos más acerca de tus intereses o necesidades?"
          className="w-full rounded border border-white/20 bg-transparent px-4 py-3 text-white placeholder-white/60 outline-none focus:border-white/60 no-placeholder-shadow resize-none h-[76px] md:h-[80px]"
          style={{
            ...fieldTextStyle,
            borderColor: neutralBorder,
            fontSize: '16px',
            // Persist glow when user has typed any characters
            textShadow:
              value.length > 0
                ? "0px 0px 14.45px #2972D7, 0px 0px 28.9px #2972D7"
                : undefined,
          }}
        />
        <span
          className="absolute bottom-2 right-3 text-white/60 text-sm"
          aria-live="polite"
        >
          ({value.length}/{maxLength})
        </span>
      </div>
    </div>
  );
};

export default MessageTextarea;
